import { defineMessages } from 'react-intl';

export default defineMessages({
	navInfoLabel: {
		id: 'teams.nav.info',
		defaultMessage: 'Info',
		description: 'Navigation option used in the Teams page navigation',
	},
	navCompanyLabel: {
		id: 'teams.nav.company',
		defaultMessage: 'Company',
		description: 'Navigation option used in the Teams page navigation',
	},
	navPaymentLabel: {
		id: 'teams.nav.payment',
		defaultMessage: 'Payment',
		description: 'Navigation option used in the Teams page navigation',
	},
	navLinkDisabledMessage: {
		id: 'teams.nav.disabled.instruction',
		defaultMessage: 'Please complete previous step',
		description: 'Instructional message, in tooltip, when the disabled nav link is hovered over.',
	},
});
